
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Churchgatetopunecabservice() {



    const cardData =
    {
        keyword: 'Churchgate to Pune Cab Service ',
        heading: 'Vedant Travels: Churchgate to Pune Cab Service ',
        headingDescription: 'Vedant Travels offers convenient and reliable cab services from Churchgate to Pune. Whether you are traveling for business, leisure, or with family, we provide a range of vehicles including sedans, SUVs, and luxury cars to ensure a comfortable journey. Our professional drivers and well-maintained fleet guarantee a safe and smooth travel experience.',

        top: 'Top Places to Visit in Pune with Vedant Travels',

       "topPlaces": [
        {
            "title": "Shaniwar Wada",
            "description": "A historic fort that was once the residence of the Peshwa rulers, Shaniwar Wada is a must-visit for history enthusiasts. The fort features impressive Maratha architecture and offers an engaging light-and-sound show that brings its fascinating history to life."
        },
        {
            "title": "Aga Khan Palace",
            "description": "Built in 1892, the Aga Khan Palace is not only a beautiful structure but also a significant historical site. It was used as a prison during the freedom struggle, and Mahatma Gandhi and his associates were held here. The palace is surrounded by lush gardens, providing a peaceful atmosphere for reflection."
        },
        {
            "title": "Sinhagad Fort",
            "description": "Located 35 km from Pune, Sinhagad Fort is a popular destination for trekkers and history lovers. The fort offers stunning views of the surrounding valleys and is known for its role in Maratha history. It’s a great place for those seeking adventure and historical exploration."
        },
        {
            "title": "Osho Ashram",
            "description": "Situated in Koregaon Park, the Osho Ashram is a globally recognized meditation and spiritual retreat center. Visitors can participate in a variety of meditation sessions and spiritual workshops, making it an ideal spot for relaxation and inner peace."
        },
        {
            "title": "Raja Dinkar Kelkar Museum",
            "description": "The Raja Dinkar Kelkar Museum houses a vast collection of Indian artifacts, including sculptures, musical instruments, and daily-use items from different historical periods. It’s a fascinating stop for anyone interested in India’s cultural heritage."
        },
        {
            "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
            "description": "A beautiful Japanese-inspired garden located in Pune, this garden is perfect for a relaxing stroll. With lush greenery, vibrant flowers, and serene ponds, it offers a peaceful escape from the busy city life."
        },
        {
            "title": "Pashan Lake",
            "description": "Pashan Lake is a serene spot, perfect for nature lovers and birdwatching enthusiasts. Surrounded by lush greenery, it provides a quiet environment for photography, walks, and peaceful reflection."
        },
        {
            "title": "Bund Garden",
            "description": "Bund Garden is a riverside park ideal for a relaxing walk, boating, or picnicking. The tranquil atmosphere and natural beauty make it a lovely spot to unwind and enjoy time with family or friends."
        },
        {
            "title": "Saras Baug",
            "description": "Saras Baug is a popular temple complex in Pune, known for its beautiful Ganesha temple and peaceful gardens. It’s a great place to enjoy a leisurely walk, relax in the gardens, or simply seek spiritual solace."
        },
        {
            "title": "Fergusson College",
            "description": "One of Pune’s oldest and most prestigious educational institutions, Fergusson College is known for its colonial-era architecture and rich academic history. It’s a beautiful campus to explore, showcasing Pune’s educational legacy and architectural beauty."
        }
    ],
   "services": [
        {
            "name": "Churchgate to Pune Taxi Fare",
            "description": "The Churchgate to Pune taxi fare depends on the vehicle and type of service chosen. For a standard sedan, the fare generally ranges between ₹2,500 to ₹3,500, while for larger vehicles like an Innova Crysta, the fare could range from ₹4,000 to ₹5,500."
        },
        {
            "name": "Mumbai Central to Pune Cab",
            "description": "For a comfortable ride from Mumbai Central to Pune, you can expect a fare of approximately ₹2,500 to ₹3,500 for a standard sedan, and for an Innova Crysta or larger vehicles, it can range between ₹4,000 to ₹5,500, depending on traffic and distance."
        },
        {
            "name": "CST to Pune Cab Service",
            "description": "The fare for a CST to Pune taxi will usually fall in the range of ₹2,500 to ₹3,500 for standard cars. A larger vehicle, such as an Innova Crysta, might cost anywhere between ₹4,000 to ₹5,500, depending on the time of day and other factors."
        },
        {
            "name": "Mazdock to Pune Taxi Service",
            "description": "From Mazdock to Pune, you can expect a fare range of approximately ₹2,500 to ₹3,500 for a sedan and ₹4,000 to ₹5,500 for an Innova Crysta or larger vehicles. This depends on your choice of vehicle and the exact pickup and drop-off points."
        },
        {
            "name": "Mumbai Central to Pune One Way Cab",
            "description": "For a one-way trip from Mumbai Central to Pune, you can expect to pay around ₹2,500 to ₹3,500 for a sedan and ₹4,000 to ₹5,500 for larger vehicles like the Innova Crysta or Ertiga. One-way fares are often more economical than round trip bookings."
        },
        {
            "name": "Nariman Point to Pune Taxi Fare",
            "description": "The fare for a Nariman Point to Pune taxi ride is usually around ₹2,500 to ₹3,500 for a standard sedan. If you prefer a more spacious vehicle, such as an Innova Crysta, it could be between ₹4,000 to ₹5,500."
        },
        {
            "name": "Gateway of India to Pune Cab",
            "description": "A Gateway of India to Pune taxi fare would fall in the range of ₹2,500 to ₹3,500 for a standard sedan. For an Innova Crysta, it could range from ₹4,000 to ₹5,500, based on availability, type of service, and distance."
        },
        {
            "name": "Worli Mumbai to Pune Cab",
            "description": "The fare for a Worli Mumbai to Pune cab service would typically range from ₹2,500 to ₹3,500 for a sedan, and ₹4,000 to ₹5,500 for a 7-seater or larger vehicle like an Innova Crysta. Prices are affected by traffic conditions and exact travel times."
        },
        {
            "name": "Best Cab Service Mumbai to Pune",
            "description": "There are several reputable cab services that offer safe, affordable, and comfortable travel from Mumbai to Pune, including options like Savaari, Ola Outstation, and Uber Intercity. You can choose from sedans, SUVs, or luxury cars based on your budget and preferences."
        },
        {
            "name": "Mumbai Central to Pune Innova Crysta",
            "description": "If you're looking for comfort and space, an Innova Crysta from Mumbai Central to Pune will cost you around ₹4,000 to ₹5,500, depending on the time of booking and the distance covered."
        },
        {
            "name": "Fort Mumbai to Pune Cab Service",
            "description": "For a taxi ride from Fort Mumbai to Pune, the fare is generally between ₹2,500 to ₹3,500 for a standard sedan, and ₹4,000 to ₹5,500 for larger vehicles such as the Innova Crysta. The fare may vary based on factors such as time of day, vehicle type, and traffic conditions."
        }
    ],


    "tableData": [
        ["Church Gate to Pune Taxi Fare", "Mumbai Central to Pune Cab"],
        ["CST to Pune Cab Service", "Mazdock to Pune Taxi Service"],
        ["Mumbai Central to Pune One Way Cab", "Nariman Point to Pune Taxi Fare"],
        ["Gateway of India to Pune Cab", "Worli Mumbai to Pune Cab"],
        ["Best Cab Service Mumbai to Pune", "Mumbai Central to Pune Innova Crysta"],
        ["Fort Mumbai to Pune Cab Service"]
      ],
      "whychoose": [
        {
          "WhyChooseheading": "Reliable and On-Time Service",
          "WhyChoosedescription": "At Vedant Travels, we understand the significance of punctuality when traveling from Church Gate to Pune. Whether it’s a business trip or leisure, we ensure timely pickups and drop-offs, ensuring you reach your destination on time with minimal stress."
        },
        {
          "WhyChooseheading": "Comfortable and Spacious Vehicles",
          "WhyChoosedescription": "We offer a variety of well-maintained, comfortable vehicles for your Church Gate to Pune journey. From sedans to SUVs, our vehicles are equipped with modern amenities, air conditioning, and spacious interiors for a pleasant and comfortable ride."
        },
        {
          "WhyChooseheading": "Experienced and Professional Drivers",
          "WhyChoosedescription": "Our drivers are highly experienced and well-acquainted with the Church Gate to Pune route. They are committed to providing safe, smooth, and efficient travel while offering a friendly, professional service throughout the journey."
        },
        {
          "WhyChooseheading": "Affordable and Transparent Pricing",
          "WhyChoosedescription": "At Vedant Travels, we provide transparent and affordable pricing for our Church Gate to Pune cab service. There are no hidden charges, and the cost of your trip will be clearly communicated during the booking process."
        },
        {
          "WhyChooseheading": "Safe and Comfortable Journey",
          "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with the latest safety features like airbags, seat belts, and GPS tracking, and our drivers follow strict safety protocols to ensure a secure and comfortable ride from Church Gate to Pune."
        },
        {
          "WhyChooseheading": "24/7 Availability",
          "WhyChoosedescription": "Whether you need a cab during the day or late at night, Vedant Travels is available 24/7. Book your Church Gate to Pune cab at any time, and our customer service team will assist you promptly."
        },
        {
          "WhyChooseheading": "Hassle-Free Booking Process",
          "WhyChoosedescription": "Booking a cab from Church Gate to Pune is easy with Vedant Travels. You can book through our website or mobile app, or simply call our customer service team for a smooth and hassle-free booking experience."
        },
        {
          "WhyChooseheading": "Customizable Travel Packages",
          "WhyChoosedescription": "We offer flexible travel packages for your Church Gate to Pune journey. Whether you're traveling for business, leisure, or any special occasion, we can customize the trip to suit your preferences and requirements."
        }
      ]
    }



    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Church Gate to Pune?',
            answer: 'You can book a cab from Church Gate to Pune online via our website or mobile app. Alternatively, you can contact our customer service team for assistance in making a booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Church Gate to Pune journey?',
            answer: 'We offer a range of vehicles, including sedans, SUVs, and premium cars, ensuring comfort and convenience for every type of traveler.',
        },
        {
            id: 3,
            question: 'What are the payment options for my Church Gate to Pune cab?',
            answer: 'We accept various payment options, including cash, credit/debit cards, and online payment via our mobile app for your convenience.',
        },
        {
            id: 4,
            question: 'Can I book a round-trip cab from Church Gate to Pune?',
            answer: 'Yes, we offer round-trip services. Just provide your return details during the booking process, and we will arrange the return journey for you.',
        },
        {
            id: 5,
            question: 'Are there extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting time or detours will be clearly communicated to you during the booking process. We believe in providing complete transparency.',
        },
        {
            id: 6,
            question: 'Can I hire a cab for sightseeing on my Church Gate to Pune trip?',
            answer: 'Yes, we offer sightseeing services as part of your Church Gate to Pune journey. If you wish to visit specific spots along the way or in Pune, we can tailor your trip accordingly.',
        },
        {
            id: 7,
            question: 'What is the luggage allowance for the cab from Church Gate to Pune?',
            answer: 'Our vehicles can accommodate standard luggage. If you have excess luggage or any special requirements, please inform us during the booking, and we’ll arrange for a vehicle that fits your needs.',
        },
        {
            id: 8,
            question: 'Is Vedant Travels available for corporate travel from Church Gate to Pune?',
            answer: 'Yes, we offer corporate travel services, providing transportation for business meetings, conferences, or team outings. Our vehicles are perfect for corporate trips between Church Gate and Pune.',
        },
        {
            id: 9,
            question: 'Why should I choose Vedant Travels for my Church Gate to Pune journey?',
            answer: 'Vedant Travels offers reliable service, professional drivers, competitive rates, and well-maintained vehicles. We prioritize customer satisfaction, ensuring a safe, comfortable, and timely journey from Church Gate to Pune.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Ramesh Gupta",
            title: "Business Traveler",
            quote: "I had a wonderful experience traveling from Church Gate to Pune with Vedant Travels. The driver was courteous, the car was clean and comfortable, and the trip was smooth. Highly recommend their services!",
            rating: 5,
        },
        {
            name: "Ms. Priya Sharma",
            title: "Business Traveler",
            quote: "I booked a cab with Vedant Travels for a business trip from Church Gate to Pune. The service was prompt and professional. The driver was knowledgeable and made the trip enjoyable. I’ll definitely use them again!",
            rating: 5,
        },
    ];
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Church Gate to Pune Cab Service | Vedant Travels",
        "description": "Book your Church Gate to Pune taxi with Vedant Travels. Offering affordable one-way and round-trip cabs, including Innova Crysta, Ertiga, and Sedan. Reliable taxi service for your journey from Church Gate to Pune, Nariman Point, Gateway of India, and more.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "320"
        }
      };
      
     const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Church Gate to Pune Cab Service",
  "image": "https://vedanttravels.in/assets/images/church-gate-to-pune-cab-service.jpg",
  "description": "Book Church Gate to Pune cab service with Vedant Travels for a safe, comfortable, and reliable journey. Choose from AC sedans and SUVs for one-way, round-trip, and airport transfers with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3900"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2399",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/church-gate-to-pune-cab-service"
  }
};





    return (
        <div>
           
          <Helmet>
  <title>Church Gate to Pune Cab Service | Safe & Reliable | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book Church Gate to Pune cab service with Vedant Travels for a safe, comfortable, and reliable journey. Choose from AC sedans and SUVs for one-way, round-trip, and airport transfers with professional drivers." 
  />
  <meta 
    name="keywords" 
    content="Church Gate to Pune Cab Service, Cab Service Church Gate Pune, Taxi Church Gate Pune, One-Way Cab Church Gate Pune, Round Trip Cab Church Gate Pune, AC Taxi Church Gate Pune, SUV Cab Church Gate Pune, Vedant Travels Church Gate, Online Cab Booking Church Gate Pune, Reliable Cab Church Gate Pune, Comfortable Ride Church Gate Pune, Affordable Taxi Church Gate Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/60.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Churchgatetopunecabservice;